import { render, staticRenderFns } from "./CoreSection.vue?vue&type=template&id=6da479d9&scoped=true"
import script from "./CoreSection.vue?vue&type=script&lang=js"
export * from "./CoreSection.vue?vue&type=script&lang=js"
import style0 from "./CoreSection.vue?vue&type=style&index=0&id=6da479d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da479d9",
  null
  
)

export default component.exports